import React, { useState, useEffect } from 'react'
import { useFilter } from '../../forms/hocs/filter.context.hoc'
import { FilterComponentProp } from '../../forms/hocs/types'
import * as styled from './digital-retailing-checkbox.styles'
import { FilterTitle } from '../expandable-filter/expandable-filter.styles'
import {
    StyledLabelAndIconContainer,
    StyledCheckBoxElement,
} from '../search-filters-checkbox/search-filters-checkbox.styles'

export const SearchFiltersDigitalRetailingCheckbox = ({ option, externalOnChange, icon }: FilterComponentProp) => {
    const { onValueChanged, selected, options, title, filterName } = useFilter()
    const isSelected = selected.length > 0
    const [isChecked, setIsChecked] = useState(isSelected)
    const value = (option || options[0])?.value
    const count = (option || options[0])?.count
    const disable = !isChecked && (count === null || !count)

    const name = `${filterName}-${value}`

    useEffect(() => {
        setIsChecked(selected.includes(value))
    }, [selected, setIsChecked, value])

    const handleChange = () => {
        setIsChecked(!isChecked)
        onValueChanged(isChecked ? [] : [value])
        externalOnChange && !isChecked ? externalOnChange() : null
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (!disable && (e.code === 'Space' || e.key === ' ')) {
            e.preventDefault()
            handleChange()
        }
    }

    return (
        <styled.DigitalRetailingCheckboxContentsContainer
            key={name}
            data-testid={`${name}-container`}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            htmlFor={`${name}-simple-checkbox`}
            disabled={disable}
        >
            <StyledLabelAndIconContainer>
                {icon && icon}
                <FilterTitle as="span" className={'digital-retailing-label'}>{`${option?.label || title}`}</FilterTitle>
            </StyledLabelAndIconContainer>
            <StyledCheckBoxElement
                name={`${name}-simple-checkbox`}
                id={`${name}-simple-checkbox`}
                className={`${name}-simple-checkbox`}
                label={''}
                disabled={disable}
                onChange={() => {}}
                checked={isChecked}
            />
        </styled.DigitalRetailingCheckboxContentsContainer>
    )
}
